import { createActionGroup, props } from '@ngrx/store';
import { MdmCommand } from '@rocksoft/mdm-sdk-v2';
import { ErrorModel } from '@era/app';

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const CommandContentApiActions = createActionGroup({
  source: 'Command Content API',
  events: {
    'Command Content loaded': props<{ commandContent: MdmCommand }>(),
    'Command Content loaded error': props<{ error: ErrorModel }>(),
  },
});

// ============================================================================
// UI ACTIONS (Group - using createActionGroup)
// ============================================================================

export const CommandContentActions = createActionGroup({
  source: 'Command Content',
  events: {
    'Command Content requested': props<{ udid: string; commandUuid: string }>(),
  },
});
